import React, { useCallback } from 'react';
import { CardBody, Card, Row, Col } from 'reactstrap';
import RemixEmbedComponent from '../../../../Layout/Components/RemixEmbedComponent';
import Strings from '../../../../translations/Translations';

export default function AnalyzeSpecific(props) {
  const { currentIt } = props;

  const renderNumber = useCallback((value) => {
    let ret = 0;
    if (value && value !== 0 && value !== '0' && value !== '00') {
      ret = value;
    }
    return `${ret}`;
  }, []);

  return (
    <CardBody>
      <Row>
        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-success" />
                <i className="lnr-eye text-success" />
              </div>
              <div className="widget-numbers">
                {currentIt && renderNumber(currentIt.rhits)}
              </div>
              <div className="widget-subheading">
                {Strings('views')}
              </div>
            </div>
          </Card>
        </Col>

        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-info" />
                <i className="lnr-thumbs-up text-info" />
              </div>
              <div className="widget-numbers">
                {currentIt && renderNumber(currentIt.rlikes)}
              </div>
              <div className="widget-subheading">
                {Strings('likes')}
              </div>
            </div>
          </Card>
        </Col>

        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-danger" />
                <i className="lnr-picture text-danger" />
              </div>
              <div className="widget-numbers">
                {currentIt && renderNumber(currentIt.rpn)}
              </div>
              <div className="widget-subheading">
                {Strings('photos')}
              </div>
            </div>
          </Card>
        </Col>

        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover br-br">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-info" />
                <i className="lnr-users text-info" />
              </div>
              <div className="widget-numbers">
                {currentIt && renderNumber(currentIt.riun)}
              </div>
              <div className="widget-subheading">
                {Strings('Users')}
              </div>
            </div>
          </Card>
        </Col>

      </Row>
      <Row>
        {currentIt && currentIt.rid && (
          <Col md={12} className="p-3 mt-5">
            <RemixEmbedComponent currentIt={currentIt} />
          </Col>
        )}
      </Row>
    </CardBody>
  );
}
